module.exports = __webpack_public_path__ + "static/media/share_facebook.52b71a43.svg";